"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasheetContentLabelIds = void 0;
var DatasheetContentLabelIds;
(function (DatasheetContentLabelIds) {
    DatasheetContentLabelIds["PinDefinitions"] = "pin-definitions";
    DatasheetContentLabelIds["PinFunctions"] = "pin-functions";
    DatasheetContentLabelIds["PinoutDiagram"] = "pinout-diagram";
    DatasheetContentLabelIds["AbsoluteMaximumRatings"] = "absolute-maximum-ratings";
    DatasheetContentLabelIds["OperatingConditions"] = "operating-conditions";
    DatasheetContentLabelIds["ElectricalCharacteristics"] = "electrical-characteristics";
    DatasheetContentLabelIds["BlockDiagram"] = "block-diagram";
    DatasheetContentLabelIds["MemoryRegister"] = "memory-register";
    DatasheetContentLabelIds["IoPorts"] = "io-ports";
    DatasheetContentLabelIds["ApplicationInformation"] = "application-information";
    DatasheetContentLabelIds["ComponentFunctions"] = "component-functions";
    DatasheetContentLabelIds["PackageInformation"] = "package-information";
    DatasheetContentLabelIds["Errata"] = "errata";
    DatasheetContentLabelIds["RevisionHistory"] = "revision-history";
    DatasheetContentLabelIds["TableOfContents"] = "table-of-contents";
    DatasheetContentLabelIds["_TableOfContentsOld"] = "toc";
    DatasheetContentLabelIds["ThermalInformation"] = "thermal-information";
    DatasheetContentLabelIds["DevelopmentTools"] = "development-tools";
    DatasheetContentLabelIds["Glossary"] = "glossary";
    DatasheetContentLabelIds["ContextCaption"] = "context-caption";
})(DatasheetContentLabelIds || (exports.DatasheetContentLabelIds = DatasheetContentLabelIds = {}));
//# sourceMappingURL=DatasheetContentLabels.js.map